
import config from "@/config/index";
import api from '../../utils/axios-util';
import { NULLVALUES } from "../mutation-types";
const state = config.dialerstate;
var getters = {
  dialerstatus: state => state.dialerstatus
}
const mutations = {
  ["DIALERSTATUS"]: (state, payload) => {
    state.dialerstatus = payload.data.data;
  },
  [NULLVALUES]: (state) => {
    state.dialerstatus = [];
  }
};

const actions = {
  DialerStatusAction: ({ commit }) => {
    return new Promise((resolve, reject) => {
      try {
        ///realtime/dialerStatus?campaign=${"campaign1"
        const campaigns = JSON.parse(localStorage.getItem("Team")) || [];

        if (campaigns.length === 0) {
          api.post("/realtime/dialerStatus",{}).then(response => {
            var dialer_response = response;
            commit("DIALERSTATUS", dialer_response);
            resolve(response);
          }).catch((error) => {
            commit("DIALERSTATUS", error);
            reject(error);
          })
        }
        else {
          let campaign
          let campaigndata = campaigns[0].campaign.map((campaign) => campaign.name);
          campaign = campaigndata.join(',');  
          const payload ={"campaign" : campaign || ""}
          api.post("/realtime/dialerStatus",payload)
          .then(response => {
            var dialer_response = response;
            commit("DIALERSTATUS", dialer_response);
            resolve(response);
          }).catch((error) => {
            commit("DIALERSTATUS", error);
            reject(error);
          })
        }
      } catch (error) {
        commit("DIALERSTATUS", error)
        reject(error)
      }
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions
};